import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import {
  IServiceFee,
  IServiceFeeCreate,
  IServiceFeeUpdate
} from "../interfaces/endpoints/IServiceFee";

export const getAllServiceFees = async (): Promise<
  IAxiosResponse<IServiceFee[]>
> => {
  return axios.get<IServiceFee[]>("/v1.0/ServiceFee/GetAll");
};

export const getServiceFeeById = async (
  id: number
): Promise<IAxiosResponse<IServiceFee>> => {
  return axios.get<IServiceFee>(`/v1.0/ServiceFee/GetById/${id}`);
};

export const createServiceFee = async (
  body: IServiceFeeCreate
): Promise<number> => {
  return axios.post("/v1.0/ServiceFee/Create", body);
};

export const updateServiceFee = async (
  body: IServiceFeeUpdate
): Promise<boolean> => {
  return axios.put("/v1.0/ServiceFee/Update", body);
};

export const deleteServiceFee = async (id: number): Promise<boolean> => {
  return axios.delete(`/v1.0/ServiceFee/Delete/${id}`);
};
